module.exports = __webpack_public_path__ + "img/down.5b696aa2.png";